
import React, { useState } from 'react';
import Bg from '../../../images/shapes/shape_title_under_line.svg'
import shape1 from '../../../images/shapes/shape_line_2.svg'
import shape2 from '../../../images/shapes/shape_line_3.svg'
import shape3 from '../../../images/shapes/shape_line_4.svg'
import shape4 from '../../../images/shapes/shape_space_3.svg'

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';
import TechnologySection from '../TechnologySection/TechnologySection';
import Testimonial from '../Testimonial/Testimonial';

const FaqSection = (props) => {

    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    return (
        <section className="process_technology_review_section bg-light section_decoration">
            <div className="container">
                <div className="row align-items-center justify-content-lg-between">
                    <div className="col-lg-6">
                        <div className="heading_block">
                            <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg})` }}>
                                Working Process
                            </div>
                            <h2 className="heading_text mb-0">
                                Our Approach <mark>Anuwebsolutions</mark>
                            </h2>
                        </div>
                        <Accordion open={open} toggle={toggle} className="accordion" id="service_process_faq">
                            <AccordionItem className="accordion-item">
                                <AccordionHeader targetId="1">
                                    01. Discovery & Consultation
                                </AccordionHeader>
                                <AccordionBody accordionId="1" className='acc_body'>
                                    <p className="m-0">
                                    We start by understanding your business goals, challenges, and target audience. Our team conducts in-depth research and brainstorming sessions to define project requirements, scope, and strategy.
                                    </p>
                                </AccordionBody>
                            </AccordionItem>
                            <AccordionItem className="accordion-item">
                                <AccordionHeader targetId="2">
                                    02. Planning & Strategy
                                </AccordionHeader>
                                <AccordionBody accordionId="2" className='acc_body'>
                                    <p className="m-0">
                                    With a clear vision in mind, we create a detailed roadmap, outlining the design, development, and deployment phases. This ensures a smooth workflow and timely delivery.
                                    </p>
                                </AccordionBody>
                            </AccordionItem>
                            <AccordionItem className="accordion-item">
                                <AccordionHeader targetId="3">
                                    03. UI/UX Design
                                </AccordionHeader>
                                <AccordionBody accordionId="3" className='acc_body'>
                                    <p className="m-0">
                                    Our design team crafts intuitive, user-friendly, and visually stunning interfaces using the latest tools like Figma and Adobe XD. We focus on enhancing user experience while maintaining brand identity.
                                    </p>
                                </AccordionBody>
                            </AccordionItem>
                            <AccordionItem className="accordion-item">
                                <AccordionHeader targetId="4">
                                    04. Agile Development
                                </AccordionHeader>
                                <AccordionBody accordionId="4" className='acc_body'>
                                    <p className="m-0">
                                    Using modern technologies like React, PHP, WordPress, Shopify, and Magento, our development team builds scalable and secure web and mobile applications. We follow Agile methodologies for flexibility and continuous improvement.
                                    </p>
                                </AccordionBody>
                            </AccordionItem>
                            <AccordionItem className="accordion-item">
                                <AccordionHeader targetId="5">
                                    05. Testing & Quality Assurance
                                </AccordionHeader>
                                <AccordionBody accordionId="5" className='acc_body'>
                                    <p className="m-0">
                                    We conduct rigorous testing, including performance, security, and usability tests, to ensure a bug-free and high-performing digital solution.Once tested and approved, we launch the project with zero downtime and provide post-launch support to ensure everything runs smoothly.
                                    </p>
                                </AccordionBody>
                            </AccordionItem>
                        </Accordion>
                    </div>
                    <div className="col-lg-5">
                        <Accordion open={open} toggle={toggle} className="accordion" id="service_process_faq">
                            <ul className="content_layer_group unordered_list_block text-center">
                                <li><AccordionHeader targetId="1"><span>Discovery & Consultation</span></AccordionHeader></li>
                                <li><AccordionHeader targetId="2"><span>Planning & Strategy</span></AccordionHeader></li>
                                <li><AccordionHeader targetId="3"><span>UI/UX Design</span></AccordionHeader></li>
                                <li><AccordionHeader targetId="4"><span>Agile Development</span></AccordionHeader></li>
                                <li><AccordionHeader targetId="5"><span>Testing & Deployment</span></AccordionHeader></li>
                            </ul>
                        </Accordion>
                    </div>
                </div>
                <TechnologySection/>
                <Testimonial/>
            </div>

            <div className="decoration_item shape_image_1">
                <img src={shape1} alt="Anuwebsolutions Shape" />
            </div>
            <div className="decoration_item shape_image_2">
                <img src={shape2} alt="Anuwebsolutions Shape" />
            </div>
            <div className="decoration_item shape_image_3">
                <img src={shape3} alt="Anuwebsolutions Shape" />
            </div>
            <div className="decoration_item shape_image_4">
                <img src={shape4} alt="Anuwebsolutions Shape" />
            </div>
        </section>
    )
};
export default FaqSection;
